import Cookies from 'js-cookie';

export default Cookies;
export type { CookieAttributes } from 'js-cookie';
export { Cookies };
